import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/CLOUDWEB-17705 Фильтрация пабликов в документах. Вы поделились */
export const YOU_SHARED_ALLDOCS_CATEGORY_ENABLED = isFeature('you-shared-alldocs-category-enabled');
